import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-digitalocean',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>DigitalOcean icon</title><path d="M12.04 0C5.408-.02.005 5.37.005 11.992h4.638c0-4.923 4.882-8.731 10.064-6.855a6.95 6.95 0 014.147 4.148c1.889 5.177-1.924 10.055-6.84 10.064v-4.61H7.391v4.623h4.61V24c7.86 0 13.967-7.588 11.397-15.83-1.115-3.59-3.985-6.446-7.575-7.575A12.8 12.8 0 0012.039 0zM7.39 19.362H3.828v3.564H7.39zm-3.563 0v-2.978H.85v2.978z"/></svg>`,
    styles: []
})
export class SimpleIconsDigitaloceanComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#0080FF';
    @Input() className: string = 'simple-icons-digitalocean'
    constructor() {}
    ngOnInit(): void {}
}
